<template>
  <div class="tw-gap-2 tw-space-y-5 md:tw-grid md:tw-space-y-0 lg:tw-gap-5" :class="containerClass">
    <StationCard
      v-for="station in selectedStationsList"
      :key="station.key"
      class="tw-h-full tw-w-full"
      :station="station"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import useSettingsStore from '@/stores/settings';
import useStationsStore from '@/stores/stations';

import StationCard from './StationCard.vue';

const stationsStore = useStationsStore();
const { selectedStationsList } = storeToRefs(stationsStore);
const settingsStore = useSettingsStore();
const { gridColumns } = storeToRefs(settingsStore);

const GRID_CLASSES = {
  1: 'tw-grid-cols-1',
  2: 'tw-grid-cols-2',
  3: 'tw-grid-cols-3',
  4: 'tw-grid-cols-4',
  5: 'tw-grid-cols-5',
  6: 'tw-grid-cols-6',
  7: 'tw-grid-cols-7',
  8: 'tw-grid-cols-8',
  9: 'tw-grid-cols-9',
  10: 'tw-grid-cols-10',
};

const autoSize = computed(() => gridColumns.value === 'auto');
const columnCount = computed(() => {
  if (autoSize.value) return null;

  const number = parseInt(gridColumns.value, 10);
  return Number.isFinite(number) ? number : null;
});

const containerClass = computed(() => {
  return GRID_CLASSES[columnCount.value] || 'tw-grid-cols-[repeat(auto-fit,minmax(360px,1fr))]';
});
</script>
